import type { SuggestedPrompt } from '@/hooks/useConfiguration'
import { cn } from '@/lib/utils'
import { useConversationContext } from '@/contexts/ConversationContext'

interface EmptyStateSuggestionsProps {
  suggestions: SuggestedPrompt[]
  onSuggestionClick: (message: string) => void
}

export function EmptyStateSuggestions({
  suggestions,
  onSuggestionClick,
}: EmptyStateSuggestionsProps) {
  const { agentId } = useConversationContext()
  if (suggestions.length === 0) return null

  const chipColor =
    agentId === 'david' ? 'text-david-solid' : 'text-hanna-solid'
  const chipRing =
    agentId === 'david'
      ? 'focus-visible:ring-david-solid/30'
      : 'focus-visible:ring-hanna-solid/30'

  return (
    <div
      data-slot="empty-state-suggestions"
      className="flex items-end flex-col justify-end gap-3 px-4 pb-3">
      {suggestions.map((s) => (
        <button
          key={`${s.title}||${s.message}`}
          type="button"
          onClick={() => onSuggestionClick(s.message)}
          title={s.title}
          className={cn(
            'max-w-full px-3 py-2 rounded-[14px]',
            'bg-white-alpha-7 hover:bg-white/80',
            'text-base text-center whitespace-nowrap truncate',
            'cursor-pointer transition-colors',
            'focus-visible:outline-none focus-visible:ring-2',
            chipColor,
            chipRing
          )}>
          {s.title}
        </button>
      ))}
    </div>
  )
}
